<template>
        <div class="wrapper-userlist">
            <div class="userlist">
                <div class="users-action">
                    <div class="search">
                        <input
                                class="form-control search"
                                v-bind:placeholder="$t('user.search')"
                                type="search"
                                v-model="searchTerm"
                                v-on:keyup.enter="changeSearch"
                                v-on:blur="changeSearch"
                        />
                        <span class="icon">
                        <font-awesome-icon :icon="['fal','search']" class="fa-icon"></font-awesome-icon>
                    </span>
                    </div>

                    <div class="actions" v-show="showActions">
                        <button class="btn btn-danger" v-on:click="action">
                            {{ $t("user.remove") }}
                        </button>
                    </div>
                </div>
                <div class="table-responsive-lg">
                    <table class="table table--overview">
                        <thead>
                        <tr>
                            <th class="small">
                                <b-form-checkbox
                                    v-model="allSelected"
                                    v-on:change="toggleAll"
                                >
                                </b-form-checkbox>
                            </th>
                          <th>
                            <a class="sorting" v-on:click="sortColumn('email')">
                                    <span class="colname">
                                        {{ $t("user.email") }}
                                    </span>
                              <span class="colsort">
                                        <font-awesome-icon v-if="sort !== 'email'" :icon="['fal','sort']"></font-awesome-icon>
                                        <font-awesome-icon v-if="sort === 'email' && dir === 'asc'" :icon="['fal','sort-down']"></font-awesome-icon>
                                        <font-awesome-icon v-if="sort === 'email' && dir === 'desc'" :icon="['fal','sort-up']"></font-awesome-icon>
                                   </span>
                            </a>
                          </th>
                          <th>
                            <a class="sorting" v-on:click="sortColumn('firstname')">
                                <span class="colname">
                                    {{ $t("user.firstname") }}
                                </span>
                              <span class="colsort">
                                    <font-awesome-icon v-if="sort !== 'firstname'" :icon="['fal','sort']"></font-awesome-icon>
                                    <font-awesome-icon v-if="sort === 'firstname' && dir === 'asc'" :icon="['fal','sort-down']"></font-awesome-icon>
                                    <font-awesome-icon v-if="sort === 'firstname' && dir === 'desc'" :icon="['fal','sort-up']"></font-awesome-icon>
                               </span>
                            </a>

                          </th>
                          <th>
                            <a class="sorting" v-on:click="sortColumn('lastname')">
                                <span class="colname">
                                    {{ $t("user.lastname") }}
                                </span>
                              <span class="colsort">
                                    <font-awesome-icon v-if="sort !== 'lastname'" :icon="['fal','sort']"></font-awesome-icon>
                                    <font-awesome-icon v-if="sort === 'lastname' && dir === 'asc'" :icon="['fal','sort-down']"></font-awesome-icon>
                                    <font-awesome-icon v-if="sort === 'lastname' && dir === 'desc'" :icon="['fal','sort-up']"></font-awesome-icon>
                               </span>
                            </a>
                          </th>
                            <th>
                                {{ $t("user.sites") }}
                            </th>
                            <th>
                                {{ $t("user.paymentvalid") }}

                            </th>
                            <th>
                                {{ $t("user.profilevalid") }}

                            </th>
                            <th>
                                {{ $t("user.serviceenabled") }}

                            </th>
                            <th>
                                {{ $t("user.predelete") }}

                            </th>
                            <th>
                              {{ $t("user.actions") }}

                            </th>

                        </tr>
                        </thead>

                        <tbody>
                            <users-item v-for="item in items" :key="item.id" v-bind="item"></users-item>
                        </tbody>

                        <tfoot>
                            <tr>
                                <td colspan="6">
                                    <nav class="page navigation" v-show="showPagination">
                                        <b-pagination
                                                align="left"
                                                v-bind:total-rows="total"
                                                v-model="currentPage"
                                                v-on:change="goToPage"
                                                v-bind:per-page="limit"
                                        >
                                        </b-pagination>
                                    </nav>

                                </td>
                            </tr>

                        </tfoot>
                    </table>
                </div>
            </div>
            <user-detail></user-detail>
        </div>
</template>

<script>

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import UsersItem from './UsersItem'
import UserDetail from './UserDetail'

export default {

  name: 'List',

  components: {
    UsersItem,
    UserDetail
  },

  props: {

    limit: {
      type: Number,
      default: 20
    }
  },

  computed: {
    ...mapGetters('common', ['isLoading']),

    ...mapState('user', {
      userSelected: state => state.userSelected,
      allSelectedState: state => state.allSelected,
      users: state => state.users
    }),

    allSelected: {
      get () {
        return this.allSelectedState
      },
      set (value) {
        // just do nothing
      }
    },

    showActions () {
      return this.userSelected.length > 0
    },

    showPagination () {
      return this.totalPages > 1
    }

  },

  data () {
    return {
      items: [],
      currentPage: 1,
      total: 1,
      totalPages: 1,
      sort: 'lastname',
      dir: 'asc',
      searchTerm: ''
    }
  },

  methods: {
    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    ...mapMutations('user', [
      'setSelectAll',
      'unSelectAll'
    ]),

    ...mapActions('user', [
      'getUsers'
    ]),

    action () {
      // meh
    },

    changeSearch () {
      this.unSelectAll()
      this.goToPage(1)
    },

    goToPage (page) {
      if (!this.isLoading) {
        this.startLoading()
      }

      let payload = {
        page: page,
        limit: this.limit,
        sort: this.sort,
        dir: this.dir,
        search: this.searchTerm
      }

      this.getUsers(payload).then(
        response => {
          /*
                            Don't use the repose data because we are converting data for easier usage, this is saved
                            locally in the globalSites var to avoid naming conflicts
                         */

          this.preparePage(this.users)
          this.endLoading()
        }
      )
    },

    preparePage (data) {
      let meta = data.meta

      this.limit = meta.pagination.per_page
      this.total = meta.pagination.total
      this.totalPages = meta.pagination.total_pages
      this.currentPage = meta.pagination.current_page

      this.items = []

      data.data.forEach((e) => {
        this.items.push(e)
      })
    },

    sortColumn (column) {
      if (this.sort === column) {
        if (this.dir === 'asc') {
          this.dir = 'desc'
        } else {
          this.dir = 'asc'
        }
      } else {
        this.sort = column
      }

      this.goToPage(1)
    },

    toggleAll (e) {
      if (this.allSelected) {
        this.unSelectAll(e)
      } else {
        this.setSelectAll(e)
      }
    }
  },

  created () {
    this.setViewname(this.$t('user.adminlist.viewtitle'))
    this.goToPage(1)
  }

}
</script>
